"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addRedPacketActivity = addRedPacketActivity;
exports.copyRedPacketActivity = copyRedPacketActivity;
exports.exportRedPacketActivity = exportRedPacketActivity;
exports.queryRedPacketActivity = queryRedPacketActivity;
exports.queryRedPacketActivityPage = queryRedPacketActivityPage;
exports.queryRedPacketActivityResendHelper = queryRedPacketActivityResendHelper;
exports.queryRedPacketActivityResendInitiator = queryRedPacketActivityResendInitiator;
exports.queryRedPacketStatisticsPage = queryRedPacketStatisticsPage;
exports.updateRedPacketActivity = updateRedPacketActivity;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var request_api_prefix = '/xyRedPacketActivity';
/**
 * 红包活动 导出数据
 * @param helperIdd 发起者ID
 * @returns {Object}
 */
function exportRedPacketActivity(params) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/activityStatisticExport',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}

/**
 * 红包活动 助力者补发优惠券
 * @param helperIdd 发起者ID
 * @returns {Object}
 */
function queryRedPacketActivityResendHelper(helperIdd) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/resend/helper/' + helperIdd,
    method: 'get'
  });
}

/**
 * 红包活动 发布者补发优惠券
 * @param params 查询参数
 * @returns {Object}
 */
function queryRedPacketActivityResendInitiator(initiatorIdd) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/resend/initiator/' + initiatorIdd,
    method: 'get'
  });
}

/**
 * 红包活动 统计分页
 */
function queryRedPacketStatisticsPage(params) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/statistics/page',
    method: 'get',
    params: params
  });
}

/**
 * 红包活动 拷贝创建
 * @param params 查询参数
 * @returns {Object}
 */
function copyRedPacketActivity(id) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/copy/' + id,
    method: 'get'
  });
}

/**
 * 分页查询红包活动分页
 * @param params 查询参数
 * @returns {Object}
 */
function queryRedPacketActivityPage(params) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/page',
    method: 'get',
    params: params
  });
}

/**
 * 根据ID查询红包活动
 * @param id 红包活动ID
 * @returns {Object}
 */
function queryRedPacketActivity(id) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/' + id,
    method: 'get'
  });
}

/**
 * 添加红包活动
 * @param data 红包活动数据
 * @returns {Object}
 */
function addRedPacketActivity(data) {
  return (0, _requestPIM.default)({
    url: request_api_prefix,
    method: 'post',
    data: data
  });
}

/**
 * 修改红包活动
 * @param id 红包活动ID
 * @param data 红包活动数据
 * @returns {Object}
 */
function updateRedPacketActivity(id, data) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/' + id,
    method: 'put',
    data: data
  });
}